import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useEffect, useState } from 'react';
import { getVesselSchedules } from '../services/ScheduleRepository';

dayjs.extend(isoWeek);

export const useVesselScheduleData = () => {
  const [rows, setRows] = useState([]);

  const fetchData = async () => {
    try {
      const data = await getVesselSchedules();
      const transformedData = data.map((item) => {
        const departureDelay = item.departureDelay;
        let status = 'OnTime';
        if (departureDelay > 7) {
          status = 'MajorDelay';
        } else if (departureDelay >= 3) {
          status = 'MinorDelay';
        }

        const etd = dayjs(item.actualETD ?? item.initialETD);

        return {
          ...item,
          departurePortName: item.departurePort.name,
          departureCountryName: item.departureCountry.name,
          destinationPortName: item.destinationPort.name,
          destinationCountryName: item.destinationCountry.name,
          shippingCompanyName: item.shippingCompany.supplierName,
          portOperatorName: item.portOperator.supplierName,
          initialETDFormatted: formatDate(item.initialETD),
          initialETAFormatted: formatDate(item.initialETA),
          actualETDFormatted: formatDate(item.actualETD),
          actualETAFormatted: formatDate(item.actualETA),
          calendarWeek: etd.isValid() ? etd.isoWeek() : null,
          status,
        };
      });
      setRows(transformedData);
    } catch (error) {
      console.error('Error fetching vessel schedules:', error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE'); // 'de-DE' for German date format (dd.mm.yyyy)
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { rows, fetchData };
};
